/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { store } from "@/main";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";
export const getRoleTree = async () => {
  try {
    const url = generateApiUrl(["globalServices", "v2", "role_tree"]);
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const output = generateRoleItems(data);
    return output;
  } catch (error) {
    throw error;
  }
};
const generateOneRole = (data) => {
  const id = pathOr(0, ["id"], data);
  const parentId = pathOr(0, ["parent_id"], data);
  const code = pathOr(null, ["code"], data);
  const caption = pathOr(null, ["caption"], data);
  const isEnable = pathOr(0, ["is_enable"], data);
  const children = pathOr([], ["children"], data).map((child) => {
    return generateRoleItems(child);
  });
  return {
    id,
    parentId,
    code,
    caption,
    isEnable,
    children,
    show: true,
  };
};
const generateListRoles = (items) => {
  return items.map((item) => generateOneRole(item));
};
const generateRoleItems = (data) => {
  return Array.isArray(data) ? generateListRoles(data) : generateOneRole(data);
};
